//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
let d=[[[0,"AASamplesEnum",1,0],[0,"BackgroundOption",1,0],[0,"DpiEnum",1,0],[0,"DrawingSizeEnum",1,0],[0,"EnhanceEdges",1,0],[0,"NativeFileBrowser",1,0],[0,"OrientEnum",1,0],[0,"Source",1,0],[0,"UnitsEnum",1,0]],[[["nImageDimensionsDouble"],"GetImageDimensionsDouble",{R_:{imageDimensionsDouble:""}},0,0],[["imageDimensionsDouble"],"SetImageDimensionsDouble",{},1,0],[["nImageDimensionsInteger"],"GetImageDimensionsInteger",{R_:{imageDimensionsInteger:""}},0,0],[["imageDimensionsInteger"],"SetImageDimensionsInteger",{},1,0],[["nCustomBackgroundColor"],"GetCustomBackgroundColor",{R_:{customBackgroundColor:""}},0,0],[["customBackgroundColor"],"SetCustomBackgroundColor",{},1,0]],[]];
SPLM.Display.StudioImageCaptureBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.StudioImageCaptureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.StudioImageCaptureBuilder.UnitsEnumType = Object.freeze({
    "Pixels" : "Pixels", "Mm" : "Mm", "Inches" : "Inches"});

SPLM.Display.StudioImageCaptureBuilder.OrientEnumType = Object.freeze({
    "Landscape" : "Landscape", "Portrait" : "Portrait"});

SPLM.Display.StudioImageCaptureBuilder.DrawingSizeEnumType = Object.freeze({
    "Isoa4" : "Isoa4", "Isoa3" : "Isoa3", "Isoa2" : "Isoa2", "Isoa1" : "Isoa1", "Isoa0" : "Isoa0", "Ansia" : "Ansia", "Ansib" : "Ansib", "Ansic" : "Ansic", "Ansid" : "Ansid", "Ansie" : "Ansie", "Custom" : "Custom"});

SPLM.Display.StudioImageCaptureBuilder.DPIEnumType = Object.freeze({
    "Dpi72" : "Dpi72", "Dpi150" : "Dpi150", "Dpi400" : "Dpi400"});

SPLM.Display.StudioImageCaptureBuilder.AASamplesEnumType = Object.freeze({
    "Sam0X" : "Sam0X", "Sam2X" : "Sam2X", "Sam4X" : "Sam4X", "Sam8X" : "Sam8X", "Sam16X" : "Sam16X"});

SPLM.Display.StudioImageCaptureBuilder.BackgroundOptions = Object.freeze({
    "Original" : "Original", "CustomColor" : "CustomColor", "Transparent" : "Transparent"});

SPLM.Display.StudioImageCaptureBuilder.SourceType = Object.freeze({
    "WorkView" : "WorkView", "Window" : "Window"});

export default SPLM;